import React from 'react';

import dynamic from 'next/dynamic';

import { InitialFormValues } from '@components/views/types';
import { useDevice } from '@contexts/device';

const DesktopCyprusSearchForm = dynamic(
  () => import('./DesktopCyprusSearchForm')
);
const MobileCyprusSearchForm = dynamic(
  () => import('./MobileCyprusSearchForm')
);

interface CyprusSearchFormProps {
  onCancel?(): void;
  initialValues?: InitialFormValues;
  setShowLoader?: (value: boolean) => void;
  isHoliday?: boolean;
}

const CyprusSearchForm = ({
  onCancel,
  initialValues,
  setShowLoader,
  isHoliday,
}: CyprusSearchFormProps) => {
  const { isDesktop } = useDevice();

  return isDesktop ? (
    <DesktopCyprusSearchForm
      setShowLoader={setShowLoader}
      initialValues={initialValues}
      onCancel={onCancel}
      isHoliday={isHoliday}
    />
  ) : (
    <MobileCyprusSearchForm
      setShowLoader={setShowLoader}
      initialValues={initialValues}
      onCancel={() => onCancel?.()}
      isHoliday={isHoliday}
    />
  );
};

export default CyprusSearchForm;
